import { render, staticRenderFns } from "./VibrationDiagram.vue?vue&type=template&id=85df8680&scoped=true&"
import script from "./VibrationDiagram.vue?vue&type=script&lang=ts&"
export * from "./VibrationDiagram.vue?vue&type=script&lang=ts&"
import style0 from "./VibrationDiagram.vue?vue&type=style&index=0&id=85df8680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df8680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
